'use client';

import { createContext, useState } from "react";

const IdeasInfoContext = createContext({
    categories: [],
    news: [],
    providers: []
});

export function IdeasInfoContextProvider(props) {
    const [categories, setCategories] = useState(props.categories);
    const [news, setNews] = useState(props.news);
    const [providers, setProviders] = useState(props.providers);
    
    const context = {
        categories: categories,
        news: news,
        providers: providers
    }

    return <IdeasInfoContext.Provider value={context}>
        {props.children}
    </IdeasInfoContext.Provider>
}

export default IdeasInfoContext;